'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PopupManager = require('./components/PopupManager.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PopupManager).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-popup-manager/lib/index.js
// module id = 594
// module chunks = 0 1 9 10 11